import railsUjs from "@rails/ujs"
railsUjs.start()
